import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import ms from 'ms';

import ItemCardShortDate from '@/components/GridItemCard/Card/components/ItemCardShortDate/ItemCardShortDate';
import { WeakRouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryBuyNowAvailable,
    getItemSummaryIsPassed,
    getItemSummaryIsSold,
    getItemSummarySellerId,
    getItemSummarySellerName,
    getItemSummaryStartTime,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getSellerUrl } from '@/utils/urls';

export type CardInfoProps = {
    isCatalogOnline: boolean;
    isLive: boolean;
    isMobile: boolean;
    isPending: boolean;
    itemId: number;
};

export const CardInfo = ({ isCatalogOnline, isLive, isMobile, isPending, itemId }: CardInfoProps) => {
    const formatMessage = useAppFormatMessage();
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isBuyNow = useAppSelector((state) => getItemSummaryBuyNowAvailable(state, itemId));
    const saleStartTs = useAppSelector((state) => getItemSummaryStartTime(state, itemId));
    const sellerId = useAppSelector((state) => getItemSummarySellerId(state, itemId));
    const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));

    const biddingWithin7Days = Date.now() > saleStartTs * 1000 - ms('7d');
    const showDateWithoutYear = isCatalogOnline && !biddingWithin7Days;

    return (
        <section
            className="flex min-w-0 justify-between [grid-area:iteminfo]"
            data-testid="myItemsCardInfo"
        >
            <span className="max-[375px]:w-auto leading-[18px] whitespace-nowrap xsMax:w-full">
                {isBuyNow ? (
                    <BodySecondary color="secondary">{formatMessage(['buy_now'])}</BodySecondary>
                ) : (
                    <ItemCardShortDate
                        allowBidding
                        itemId={itemId}
                        showDateWithoutYear={showDateWithoutYear}
                        showOnlyYear={isSold || isPassed || isPending}
                    />
                )}
            </span>
            {!isLive && !isMobile && (
                <WeakRouteLink
                    className="group max-w-[50%] truncate text-right leading-[18px] no-underline"
                    data-testid="cardInfoAuctionHouseName"
                    to={getSellerUrl(sellerId, sellerName)}
                >
                    <BodySecondary
                        className="group-hover:!text-link-primary group-hover:!underline"
                        color="secondary"
                    >
                        {sellerName}
                    </BodySecondary>
                </WeakRouteLink>
            )}
        </section>
    );
};
